export const connectionType = {
    wifi: 0,
    realtime: 1,
    none: 2,
};

export const carConnectionType = {
  notCommunicatingCarEnabled: 2, // Connection
};

export const isStale = function (car) {
  return car.Connection === connectionType.none;
};

export const isWifi = function (car) {
  return car.Connection === connectionType.wifi;
};

export const isCellular = function (car) {
    return car.Connection === connectionType.realtime;
};
